import { ComponentRoute } from '@/classes'

const DebtorListRoutes = {
  DebtorListListView: new ComponentRoute('/debtorlists', 'DebtorListListView')
}

export default DebtorListRoutes
